import React, { useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useParams } from 'react-router-dom';
import useDocumentTitle from '../components/useDocumentTitle';

import PageHeader from '../components/PageHeader';
import ErrorWrapper from '../components/ErrorWrapper';
import Loading from '../components/Loading';
import SuccessAlert from '../components/SuccessAlert';

import MyAuthContext from '../context/AuthContext';

export const style = {
    formInput: "block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-teal-500 peer ",
    formLabel: "peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-2 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-teal-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
}

const ChangePassword = () => {
    useDocumentTitle("Cambiar contraseña")
    const { recoverPasswordChange, loading } = useContext(MyAuthContext);
    const { userEmail, userToken } = useParams();

    const [successAlert, setSuccessAlert] = useState(null);
    const [error, setError] = useState({ "error": false, "message": "" });
    const [shownPassword, setShownPassword] = useState(false);
    const [shownConfirmPassword, setShownConfirmPassword] = useState(false);

    const switchShownPassword = () => setShownPassword(!shownPassword)
    const switchConfirmShownPassword = () => setShownConfirmPassword(!shownConfirmPassword)

    const schema = yup.object().shape({
        userPassword: yup.string().required("La contraseña es requerida").min(8, "La contraseña debe tener al menos 8 caracteres").matches(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@$!%*?&#.])[A-Za-z0-9@$!%*?&#.]+$/, "La contraseña debe contener 1 mayuscula, 1 miniscula, 1 numero y uno de los siguientes caracteres: @$!%*?&#.").max(24, "Contraseña demasiado larga"),
        confirmUserPassword: yup.string().oneOf([yup.ref("userPassword")], "Las contraseñas no coinciden").required("La contraseña es requerida"),
    })

    const { handleSubmit, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        data.userEmail = userEmail
        data.userToken = userToken
        const res = await recoverPasswordChange(data)
        if (res.error) {
            setError({ "error": true, "message": res.response })
            setTimeout(() => {
                setError({ "error": false, "message": "" })
            }, 3000);
        } else {
            setSuccessAlert("Contraseña cambiada exitosamente")
            reset()
            setError({ "error": false, "message": "" })
            setTimeout(() => {
                window.location.assign('/')
                setSuccessAlert(null)
            }, 3000);
        }
    }

    return (
        <>
            <PageHeader tittle="CAMBIAR CONTRASEÑA" />
            <SuccessAlert isVisible={successAlert} />
            <div className='md:px-5 px-1'>
                <div className='flex flex-col md:flex-row w-full p-6'>
                    <form onSubmit={handleSubmit(onSubmit)} class="space-y-4 flex flex-col sm:w-[50%] w-full mx-auto bg-white p-6 rounded rounded-2xl">
                    <h1 class="text-xl font-bold leading-tight tracking-tight  md:text-2xl">Cambiar contraseña</h1>
                    <p class='text-sm font-light text-gray-500 my-6'>En los campos señalados con * es obligatorio ingresar la informacion solicitada.</p>
                        <div class="flex flex-col mx-auto w-full">
                            <div class="mb-6">
                                <div class="relative z-0 w-full group">
                                    <input type={shownPassword ? 'text' : 'password'} {...register("userPassword")} class={style.formInput} placeholder=" " />
                                    <button class="absolute transform  translate-y-[-50%] top-[50%] right-3" type="button" onClick={switchShownPassword}>
                                        {shownPassword ? <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg> : <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path></svg>}
                                    </button>
                                    <label class={style.formLabel}>Nueva Contraseña*</label>

                                </div>
                                <ErrorWrapper error={errors.userPassword?.message} />
                            </div>
                            <div class="mb-6 ">
                                <div class="relative z-0 w-full group">
                                    <input type={shownConfirmPassword ? 'text' : 'password'} {...register("confirmUserPassword")} class={style.formInput} placeholder=" " />
                                    <button class="absolute transform  translate-y-[-50%] top-[50%] right-3" type="button" onClick={switchConfirmShownPassword}>
                                        {shownConfirmPassword ? <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg> : <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path></svg>}
                                    </button>
                                    <label class={style.formLabel}>Confirmar Contraseña*</label>
                                </div>
                                <ErrorWrapper error={errors.confirmUserPassword?.message} />
                            </div>
                        </div>

                        <div className='text-center w-full'>
                            {error.error && <ErrorWrapper error={error.message} />}
                        </div>
                        {loading ? <Loading isLoading={true} /> : <button type="submit" class="flex mx-auto bg-gray-300 border shadow hover:text-white hover:bg-teal-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm w-full w-auto px-5 py-2.5 text-center">Cambiar contraseña</button>}
                    </form>
                </div>
            </div>
        </>
    );
}

export default ChangePassword;